import './MessageUserWidget.css';

export default function MessageUser({ message }) {
    return (
        <div className="messagewidget-user-row">
            <div className="messagewidget-user-bubble">
                {message}
            </div>
        </div>
    );
}
